/* fuga-motion.js v1 — globales Motion-System für Fūga Studios.
   Generalisiert aus fuga-niche-directory.js V4 ("Director's Cut").
   Opt-in per data-Attribut, kein Markup-Zwang, kein Framework.

   Attribute:
     data-fm-reveal            Fade + Lift (22px) beim Eintritt in den Viewport
     data-fm-reveal="t"        Transform-only (LCP-safe — für Bild-Karten, keine Opacity)
     data-fm-reveal="l" / "r"  slidet von links / rechts rein (Media-Splits)
     data-fm-group             Stagger-Container: Kinder mit data-fm-reveal versetzt (55ms, max 10)
     data-fm-letters           Letter-Stagger für Display-Headlines (26ms/Char) — nur reine Textknoten
     data-fm-words             Word-Stagger mit Clip-Rise (70ms/Wort) — nur reine Textknoten
     data-fm-parallax          Media-Parallax (translateY ±12% + scale bis 1.10), misst das Parent-Frame
     data-fm-ghost             Watermark-Drift (60px) + Opacity-Atmen

   Disziplin (wie V4): transform/opacity-only · ein rAF-Loop · IO mit unobserve ·
   passive Listeners · prefers-reduced-motion => komplett statisch (Klassen werden
   nie gesetzt, Inhalt bleibt sichtbar) · Theme-Editor-Reload via shopify:section:load.

   API: window.FugaMotion.scan(root) — nachgeladene Inhalte (Load-more etc.) nachregistrieren.
*/
(function () {
  'use strict';
  if (window.__fugaMotionInit) return;
  window.__fugaMotionInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var STAGGER_MS = 70, STAGGER_CAP = 10, LETTER_MS = 42, WORD_MS = 110, WORD_BASE_MS = 200;

  /* ---------- Reveal-Observer ---------- */
  var io = null;
  if (hasIO && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target;
        io.unobserve(t);
        if (t.__fmKind === 'letters') { t.classList.add('fm-letters-in'); return; }
        if (t.__fmKind === 'words') { t.classList.add('fm-words-in'); return; }
        t.style.transitionDelay = (t.__fmi * STAGGER_MS) + 'ms';
        t.classList.remove('fm-pre', 'fm-pre-t');
        t.classList.add('fm-in');
        t.addEventListener('transitionend', function te() {
          t.style.transitionDelay = '';
          t.removeEventListener('transitionend', te);
        });
      });
    }, { rootMargin: '0px 0px 10% 0px', threshold: 0.01 });
  }

  /* ---------- Guard: Niche-Directory hat eigenes V4-System ---------- */
  function inND(el) { return !!(el.closest && el.closest('.fuga-nd')); }

  /* ---------- Text-Splitting (nur reine Textknoten, aria-safe) ---------- */
  function isPlainText(el) {
    return el.children.length === 0 && el.textContent.trim().length > 0;
  }

  /* Words erlaubt zusätzlich <br> (Hero-Headlines mit Zeilenumbrüchen) */
  function isWordable(el) {
    if (el.textContent.trim().length === 0) return false;
    return [].slice.call(el.children).every(function (c) { return c.tagName === 'BR'; });
  }

  function splitLetters(el) {
    var text = el.textContent;
    el.setAttribute('aria-label', text.trim());
    el.classList.add('fm-letters');
    el.innerHTML = '';
    text.split('').forEach(function (ch, i) {
      var s = document.createElement('span');
      s.className = 'fm-ch';
      s.setAttribute('aria-hidden', 'true');
      s.style.transitionDelay = (i * LETTER_MS) + 'ms';
      s.textContent = ch === ' ' ? ' ' : ch;
      el.appendChild(s);
    });
  }

  function splitWords(el) {
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    el.classList.add('fm-words');
    var nodes = [].slice.call(el.childNodes);
    el.innerHTML = '';
    var i = 0;
    nodes.forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'BR') {
        el.appendChild(document.createElement('br'));
        return;
      }
      if (node.nodeType !== 3) return;
      node.textContent.split(/\s+/).forEach(function (w) {
        if (!w) return;
        var wrap = document.createElement('span');
        wrap.className = 'fm-wm';
        wrap.setAttribute('aria-hidden', 'true');
        var inner = document.createElement('span');
        inner.className = 'fm-w';
        inner.style.transitionDelay = (WORD_BASE_MS + i * WORD_MS) + 'ms';
        inner.textContent = w;
        wrap.appendChild(inner);
        el.appendChild(wrap);
        el.appendChild(document.createTextNode(' '));
        i++;
      });
    });
  }

  /* ---------- rAF-Loop: Parallax + Ghost ---------- */
  var pxItems = [];   /* {el, frame} */
  var ghItems = [];   /* {el, host} */
  var ticking = false;

  function progressOf(rect, vh) {
    if (rect.bottom < -160 || rect.top > vh + 160) return null;
    return (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    var i, it, p, ap;
    for (i = 0; i < pxItems.length; i++) {
      it = pxItems[i];
      p = progressOf(it.frame.getBoundingClientRect(), vh);
      if (p === null) continue;
      ap = Math.min(Math.abs(p), 1);
      it.el.style.transform = 'translate3d(0,' + (p * -12).toFixed(3) + '%,0) scale(' + (1 + ap * 0.10).toFixed(4) + ')';
    }
    for (i = 0; i < ghItems.length; i++) {
      it = ghItems[i];
      p = progressOf(it.host.getBoundingClientRect(), vh);
      if (p === null) continue;
      it.el.style.transform = 'translate3d(0,' + (p * 60).toFixed(1) + 'px,0)';
      it.el.style.opacity = (0.05 + (1 - Math.min(Math.abs(p), 1)) * 0.07).toFixed(3);
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  var loopBound = false;
  function bindLoop() {
    if (loopBound || reduce) return;
    loopBound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---------- Header hide-on-scroll (mobile ≤749px) ---------- */
  (function () {
    var header = document.querySelector('.fuga-header');
    if (!header) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var lastY = window.pageYOffset, acc = 0;
    function anyOverlayOpen() {
      return /(^|\s)\S*open\S*(\s|$)/.test(document.body.className) ||
             (document.activeElement && header.contains(document.activeElement));
    }
    window.addEventListener('scroll', function () {
      if (!mq.matches) { header.classList.remove('fm-header-hidden'); return; }
      var y = window.pageYOffset;
      var d = y - lastY;
      lastY = y;
      if (y < 160 || anyOverlayOpen()) { header.classList.remove('fm-header-hidden'); acc = 0; return; }
      acc = (d > 0) === (acc > 0) ? acc + d : d;
      if (acc > 90) header.classList.add('fm-header-hidden');
      else if (acc < -8) header.classList.remove('fm-header-hidden');
    }, { passive: true });
  })();

  /* ---------- Mobile-Peek: Karte im Viewport-Mittelband zeigt 2. Bild ---------- */
  var peekIO = null;
  (function () {
    var coarse = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    if (!coarse || !hasIO || reduce) return;
    peekIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target;
        if (en.isIntersecting) {
          clearTimeout(el.__fmPeekT);
          el.__fmPeekT = setTimeout(function () { el.classList.add('fm-peek'); }, 650);
        } else {
          clearTimeout(el.__fmPeekT);
          el.classList.remove('fm-peek');
        }
      });
    }, { rootMargin: '-38% 0px -38% 0px', threshold: 0.01 });
  })();

  /* ---------- Scan: registriert alles unterhalb von root ---------- */
  function scan(root) {
    root = root || document;
    if (reduce || !hasIO) return;

    /* Reveals — Stagger-Index je data-fm-group (Fallback: Eltern-Element) */
    var groups = [];
    [].slice.call(root.querySelectorAll('[data-fm-reveal]')).forEach(function (el) {
      if (el.__fm || inND(el)) return;
      el.__fm = true;
      var g = el.closest('[data-fm-group]') || el.parentElement || document.body;
      var gi = groups.indexOf(g);
      if (gi === -1) { groups.push(g); g.__fmCount = 0; }
      el.__fmi = Math.min(g.__fmCount++, STAGGER_CAP);
      var mode = el.getAttribute('data-fm-reveal');
      el.classList.add(mode === 't' ? 'fm-pre-t' : 'fm-pre');
      if (mode === 'l') el.classList.add('fm-from-l');
      if (mode === 'r') el.classList.add('fm-from-r');
      io.observe(el);
    });

    /* Headlines */
    [].slice.call(root.querySelectorAll('[data-fm-letters]')).forEach(function (el) {
      if (el.__fm || inND(el) || !isPlainText(el)) return;
      el.__fm = true;
      el.__fmKind = 'letters';
      splitLetters(el);
      io.observe(el);
    });
    [].slice.call(root.querySelectorAll('[data-fm-words]')).forEach(function (el) {
      if (el.__fm || inND(el) || !isWordable(el)) return;
      el.__fm = true;
      el.__fmKind = 'words';
      splitWords(el);
      io.observe(el);
    });

    /* Karten-Grids: direkte Kinder transform-only staggern (LCP-safe).
       MutationObserver registriert nachgeladene Karten (Load-more). */
    [].slice.call(root.querySelectorAll('[data-fm-cards]')).forEach(function (grid) {
      if (grid.__fmCards || inND(grid)) return;
      grid.__fmCards = true;
      function reg(el, i) {
        if (el.__fm || el.nodeType !== 1) return;
        el.__fm = true;
        el.__fmi = Math.min(i, STAGGER_CAP);
        el.classList.add('fm-pre-t');
        io.observe(el);
      }
      [].slice.call(grid.children).forEach(reg);
      if ('MutationObserver' in window) {
        new MutationObserver(function (muts) {
          muts.forEach(function (m) {
            [].slice.call(m.addedNodes).forEach(function (n, i) { reg(n, i); });
          });
        }).observe(grid, { childList: true });
      }
    });

    /* Mobile-Peek-Registrierung (nur Karten mit Hover-Bild) */
    if (peekIO) {
      [].slice.call(root.querySelectorAll('.fuga-pc__media')).forEach(function (m) {
        if (m.__fmPeek || !m.querySelector('.fuga-pc__img--hover')) return;
        m.__fmPeek = true;
        peekIO.observe(m);
      });
    }

    /* Parallax auf alle <img> eines markierten Frames (image_tag-kompatibel) */
    [].slice.call(root.querySelectorAll('[data-fm-parallax-imgs]')).forEach(function (frame) {
      if (frame.__fmPx || inND(frame)) return;
      frame.__fmPx = true;
      [].slice.call(frame.querySelectorAll('img')).forEach(function (img) {
        if (img.__fm) return;
        img.__fm = true;
        img.style.willChange = 'transform';
        pxItems.push({ el: img, frame: frame });
      });
    });

    /* Parallax + Ghost */
    [].slice.call(root.querySelectorAll('[data-fm-parallax]')).forEach(function (el) {
      if (el.__fm || inND(el)) return;
      el.__fm = true;
      pxItems.push({ el: el, frame: el.parentElement || el });
    });
    [].slice.call(root.querySelectorAll('[data-fm-ghost]')).forEach(function (el) {
      if (el.__fm || inND(el)) return;
      el.__fm = true;
      ghItems.push({ el: el, host: el.closest('[data-fm-ghost-host]') || el.parentElement || el });
    });

    if (pxItems.length || ghItems.length) { bindLoop(); update(); }
  }

  window.FugaMotion = { scan: scan };

  /* Theme-Editor: Sektion neu geladen => nachregistrieren */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
})();
